export default Object.freeze({
  locale: 'hr-HR', // supported: en-US, hr-HR
  apiURL: 'https://heroesgoals.com:7153/api',
  localUrl: 'https://localhost:7153/api',
  prodUrl: 'https://heroesgoals.com:7153/api'
});